<div class="main-content">
  <app-header [title]="(isEdit ? 'COMPANY_GROUP.EDIT_TITLE' : 'COMPANY_GROUP.CREATE_TITLE') | translate" />

  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">

      @if (!isSuccess && !isError && !isDeleteSuccess && !isDeleteError) {
        <app-icam-container [centralIcon]="true" [iconName]="'company-group'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
          @if (!isLoading) {
            <form
              [formGroup]="form"
              (ngSubmit)="onSubmit()"
              class="form-container d-flex flex-column"
            >
              <div class="form-section w-100">
                <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
                  <div class="d-flex align-items-center p-2">
                    <img class="section-image" src="assets/icon/dark/company-group.svg" alt="company-group" />
                  </div>
                  <div class="form-title-text-container">
                    <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                      {{ 'COMPANY_GROUP.GROUP_DATA' | translate }}
                    </p>
                  </div>
                </div>

                <!-- Nome -->
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <label for="name">{{ 'COMPANY_GROUP.NAME' | translate }}*</label>
                      <app-icam-input
                        inputId="name"
                        [isSlim]="true"
                        inputType="text"
                        formControlName="name"
                        [placeholder]="'COMPANY_GROUP.NAME_PLACEHOLDER' | translate"
                        [ngClass]="isLight ? 'light' : 'dark'"
                        [required]="true"
                      />
                      @if (form.get('name')?.invalid && form.get('name')?.touched) {
                        <div class="invalid-feedback d-block">
                          {{ 'COMPANY_GROUP.NAME_REQUIRED' | translate }}
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- Descrizione -->
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <label for="description">{{ 'COMPANY_GROUP.DESCRIPTION' | translate }}</label>
                      <textarea
                        class="form-control"
                        id="description"
                        formControlName="description"
                        rows="3"
                        [placeholder]="'COMPANY_GROUP.DESCRIPTION_PLACEHOLDER' | translate"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <!-- Submit -->
                <button
                  type="submit"
                  class="button-form-submit"
                  [class.disabled]="form.invalid || isLoading"
                  [disabled]="form.invalid || isLoading"
                >
                  {{ isEdit ? ('COMPANY_GROUP.SAVE_CHANGES' | translate) : ('COMPANY_GROUP.SAVE' | translate) }}
                </button>
              </div>
            </form>
          }

          @if (isLoading) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
        </app-icam-container>
      }

      <!-- Success create/edit -->
      @if (isSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ (isEdit ? 'COMPANY_GROUP.UPDATE_SUCCESS' : 'COMPANY_GROUP.CREATE_SUCCESS') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ (isEdit ? 'COMPANY_GROUP.UPDATE_SUCCESS_DESCRIPTION' : 'COMPANY_GROUP.CREATE_SUCCESS_DESCRIPTION') | translate }}
            </p>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      <!-- Success delete -->
      @if (isDeleteSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">{{ 'COMPANY_GROUP.DELETE_SUCCESS' | translate }}</h1>
            <p class="subtitle my-3">{{ 'COMPANY_GROUP.DELETE_SUCCESS_DESCRIPTION' | translate }}</p>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      <!-- Error create/edit -->
      @if (isError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ (isEdit ? 'COMPANY_GROUP.UPDATE_ERROR' : 'COMPANY_GROUP.CREATE_ERROR') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ (isEdit ? 'COMPANY_GROUP.UPDATE_ERROR_DESCRIPTION' : 'COMPANY_GROUP.CREATE_ERROR_DESCRIPTION') | translate }}
            </p>
            @if (errorMessage) {
              <p class="text-danger">{{ errorMessage }}</p>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="isError = false">{{ 'COMMON.TRY_AGAIN' | translate }}</button>
              <button class="btn btn-outline-primary" (click)="goToList()">{{ 'COMMON.RETURN_TO_LIST' | translate }}</button>
            </div>
          </div>
        </app-icam-container>
      }

      <!-- Error delete -->
      @if (isDeleteError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">{{ 'COMPANY_GROUP.DELETE_ERROR' | translate }}</h1>
            <p class="subtitle my-3">{{ 'COMPANY_GROUP.DELETE_ERROR_DESCRIPTION' | translate }}</p>
            @if (errorMessage) {
              <p class="text-danger">{{ errorMessage }}</p>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="isDeleteError = false">{{ 'COMMON.TRY_AGAIN' | translate }}</button>
              <button class="btn btn-outline-primary" (click)="goToList()">{{ 'COMMON.RETURN_TO_LIST' | translate }}</button>
            </div>
          </div>
        </app-icam-container>
      }

      <!-- Footer -->
      <div class="form-footer d-flex justify-content-between mt-4">
        <app-back-button
          class="app-back-button"
          [linkText]="'COMPANY_GROUP.BACK_TO_LIST' | translate"
          (click)="goBack()"
        />

        @if (isEdit && !isSuccess && !isError && !isDeleteSuccess && !isDeleteError) {
          <button
            type="button"
            class="btn btn-outline-danger"
            (click)="onDelete()"
            [disabled]="isLoading"
          >
            {{ 'COMPANY_GROUP.DELETE' | translate }}
          </button>
        }
      </div>

    </div>
  </div>
</div>
<app-footer-copyright />
